import { render, staticRenderFns } from "./BookingAddressesListPage.vue?vue&type=template&id=3116434f&scoped=true&"
import script from "./BookingAddressesListPage.vue?vue&type=script&lang=js&"
export * from "./BookingAddressesListPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingAddressesListPage.vue?vue&type=style&index=0&id=3116434f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3116434f",
  null
  
)

export default component.exports